<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="DEDI" id="_idParaDest-2">For Jamie</p>
<div class="hr">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?272bdd7a